// extracted by mini-css-extract-plugin
export default {"team":"Team_team__zS6eY","container":"Team_container__hLN+c","members":"Team_members__4odCr","member":"Team_member__VhDda","image":"Team_image__dk8LS","links":"Team_links__u+xeV"};